export default "__VITE_ASSET__CGIzQxdU__"